import { render, staticRenderFns } from "./DialogMessageList.vue?vue&type=template&id=8b035a3a"
import script from "./DialogMessageList.vue?vue&type=script&lang=js"
export * from "./DialogMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports